'use strict';

const _=require('pulsar-utils/dist-es6/_');
const Formatters=require('../../../../../../dist-es6/client/formatters');
const BaseControllerBackedDirective=require('../../../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

ReportRasterScheduleDirective=class ReportRasterScheduleDirective extends BaseControllerBackedDirective{
get objectBindings(){
return[
'displayTimeZone',
'timezoneDescription',
'timeOfLastHosStatus',
'timezone',
'dailySchedules',
'personalSchedule',
'fatigueThreshold',
'now',
'timeOfLastScheduleUpdate',
'invalidDataWarning',
'predictedWorkday',
'forecastDutyInterval',
'weekFormatter',
'sleepFormatter',
'personalStatistics'];
}

get templateUrl(){
return'/templates/features/fatigueReport/components/reportRasterSchedule/reportRasterScheduleView';
}

get controller(){
return ReportRasterScheduleDirectiveController;
}};let


ReportRasterScheduleDirectiveController=class ReportRasterScheduleDirectiveController{
constructor(displaySettingsService){
this._use24HourTimeline=displaySettingsService.use24HourTimeline;

this.axisLabelFormatter=this._use24HourTimeline?Formatters.utcAxisTimeLabel_24Hour:
Formatters.utcAxisTimeLabel;
}};


module.exports=ReportRasterScheduleDirective;
//# sourceMappingURL=reportRasterScheduleDirective.js.map
